import { Globe } from "lucide-react";
import { UnknownCallout } from "../components/UnknownCallout";

export const GeographicDistribution = ({
  countryData,
  totalApps,
  numCountries,
  countryUnknown,
  showUSA,
  onToggleUSA,
}) => (
  <div className="bg-card border border-border rounded-xl p-5">
    <div className="flex items-center justify-between mb-1">
      <h3 className="text-base font-semibold flex items-center gap-2">
        <Globe className="w-4 h-4 text-primary" />
        Geographic Distribution
      </h3>
      <button
        onClick={onToggleUSA}
        className="text-xs px-3 py-1 rounded-lg bg-muted hover:bg-muted/80 transition-colors"
        data-testid="toggle-usa-btn"
      >
        {showUSA ? "Hide USA" : "Show USA"}
      </button>
    </div>
    <p className="text-xs text-muted-foreground mb-4">
      {numCountries || 0} countries represented.{" "}
      {countryUnknown > 0 ? `${countryUnknown.toLocaleString()} apps have no country data.` : ""}{" "}
      Top 20 shown below.
    </p>
    <div className="space-y-1.5">
      {countryData.slice(0, 20).map((c, i) => {
        const maxVal = countryData[0]?.count || 1;
        const pct = ((c.count / totalApps) * 100).toFixed(1);
        const barPct = Math.max((c.count / maxVal) * 100, 2);
        const bg = i === 0
          ? "linear-gradient(90deg, #8b5cf6, #6366f1)"
          : `hsl(${250 - i * 8}, 60%, ${55 + i}%)`;
        return (
          <div
            key={c.country}
            className="flex items-center gap-2 group"
            data-testid={`country-bar-${c.country}`}
          >
            <span className="text-xs text-muted-foreground w-5 text-right tabular-nums">{i + 1}</span>
            <span className="text-xs font-medium w-24 truncate">{c.country}</span>
            <div className="flex-1 h-5 bg-muted/20 rounded overflow-hidden relative">
              <div
                className="h-full rounded transition-all duration-500"
                style={{ width: `${barPct}%`, background: bg }}
              />
              <span className="absolute inset-y-0 right-2 flex items-center text-[10px] font-semibold text-foreground/80">
                {c.count.toLocaleString()} <span className="text-muted-foreground ml-1">({pct}%)</span>
              </span>
            </div>
          </div>
        );
      })}
      {countryData.length > 20 && (
        <div className="flex items-center gap-2 pt-1 border-t border-border/50 mt-2">
          <span className="text-xs text-muted-foreground w-5 text-right">&nbsp;</span>
          <span className="text-xs font-medium w-24 text-muted-foreground">Others</span>
          <div className="flex-1">
            <span className="text-xs text-muted-foreground">
              {countryData.slice(20).reduce((s, c) => s + c.count, 0).toLocaleString()} apps across{" "}
              {countryData.length - 20} more countries
            </span>
          </div>
        </div>
      )}
    </div>
    {countryUnknown > 0 && (
      <UnknownCallout
        count={countryUnknown}
        total={totalApps}
        label="country"
        note="Primarily HuggingFace community projects without geographic attribution. Variants normalized (US→USA, UK, UAE→United Arab Emirates)."
      />
    )}
  </div>
);

export default GeographicDistribution;
